import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { PayPalBadge } from './PayPalBadge';

const Footer = () => {
  return (
    <footer className="bg-navy text-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-heading text-3xl font-light text-gold">JMD WILDLIFE</h3>
            <p className="font-body text-sm text-sand/80">
              Experience the untamed majesty of Tadoba Tiger Reserve with comfort and luxury.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-gold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="font-body text-sm hover:text-gold transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/packages" className="font-body text-sm hover:text-gold transition-colors">
                  Tour Packages
                </Link>
              </li>
              <li>
                <Link to="/safari-library" className="font-body text-sm hover:text-gold transition-colors">
                  Safari Library
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-body text-sm hover:text-gold transition-colors">
                  About Tadoba
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-body text-sm hover:text-gold transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation-policy"
                  className="font-body text-sm hover:text-gold transition-colors"
                  data-testid="footer-cancellation-link"
                >
                  Cancellation Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="font-body text-sm hover:text-gold transition-colors"
                  data-testid="footer-terms-link"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-gold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-gold mt-1" />
                <span className="font-body text-sm">TADOBA, Chandrapur, Maharashtra, INDIA</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-gold" />
                <span className="font-body text-sm">+91 7776828551</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-gold" />
                <span className="font-body text-sm">jmdofficials08@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-gold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-sand/10 hover:bg-gold/20 p-3 rounded-full transition-colors"
              >
                <Facebook size={20} className="text-sand" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-sand/10 hover:bg-gold/20 p-3 rounded-full transition-colors"
              >
                <Instagram size={20} className="text-sand" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-sand/10 hover:bg-gold/20 p-3 rounded-full transition-colors"
              >
                <Twitter size={20} className="text-sand" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gold/20 mt-12 pt-8">
          <div className="mb-6">
            <p className="text-center font-accent text-[10px] uppercase tracking-[0.3em] text-gold/60 mb-4">
              Trusted & Secure Payments
            </p>
            <PayPalBadge variant="inline" />
          </div>
          <p className="font-body text-sm text-sand/60 text-center">
            © 2026 JMD WILDLIFE - Tadoba Tiger Reserve. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;